<template>
  <div>
    <template v-if="facebookPostList && !selectedPost">
      <v-card
        class="pa-2 text-xs-center grey lighten-3"
        style="cursor: pointer"
        @click="listPostsModal = true"
      >
        <span class="pr-1">Select Post</span>
      </v-card>
    </template>
    <template v-else>
      <v-card
        class="pa-2 text-xs-center primary white--text"
        style="cursor: pointer"
        @click="listPostsModal = true"
      >
        <span class="pr-1">Selected Post</span>
      </v-card>
    </template>

    <v-dialog v-model="listPostsModal" persistent width="800px">
      <v-card class="pa-4">
        <div class="text-xs-right">
          <v-btn ripple icon color="primary" @click="listPostsModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <template v-if="filterPosts && filterPosts.length > 0">
          <div>
            <v-layout wrap>
              <v-flex xs6>
                <div class="primary--text">เลือกโพสต์</div>
              </v-flex>
              <v-flex xs6 class="text-xs-right form-control">
                <input v-model="search" type="text" placeholder="search" name="search" />
              </v-flex>
              <v-flex xs12 sm12 class="text-xs-center text-sm-left">
                <v-pagination
                  v-model="pageNumber"
                  :total-visible="6"
                  :length="pagelength"
                  @input="changePage"
                ></v-pagination>
              </v-flex>
            </v-layout>
          </div>
          <div
            v-for="(post, i) in filterPosts"
            :key="i"
            style="border: 1px solid #ff706b; border-radius: 4px"
            class="pa-2 my-2"
          >
            <v-layout wrap>
              <v-flex xs8 sm8 class="pa-2">
                {{ post.message }}
              </v-flex>
              <v-flex xs4 sm4 class="text-xs-center">
                <v-btn
                  :color="selectedPost == post.id ? 'primary' : 'gray'"
                  @click="onSelectedPost(post.id)"
                >
                  <span v-if="selectedPost == post.id">Selected</span>
                  <span v-else>Select</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </template>
        <template v-else class="text-xs-center">
          <span>No data available</span>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  props: ['value', 'isAgentPerformance'],
  data() {
    return {
      listPostsModal: false,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      size: 10,
      facebookPostList: [],
      postCount: 0,
      search: '',
      selectedPost: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength: function () {
      let l = this.postCount
      let s = this.size
      return Math.ceil(l / s)
    },
    filterPosts: function () {
      let vm = this
      let posts = vm.facebookPostList
      var p = []

      if (vm.search == '') {
        p = posts
      } else {
        p = posts.filter((post) => {
          return post.message.includes(vm.search)
        })
      }

      this.postCount = p && p.length ? p.length : 0

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return p.slice(start, end)
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.facebookPostList = newVal
      if (this.facebookPostList) {
        this.postCount = this.facebookPostList.length
      }

      this.postCount = p && p.length ? p.length : 0

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return p.slice(start, end)
    }
  },
  async mounted() {
    await this.getFacebookPost()
    if (this.value) {
      this.facebookPostList = this.value
      if (this.facebookPostList && !this.isAgentPerformance) {
        this.postCount = this.facebookPostList.length
        this.selectedPost = this.facebookPostList[0].id
      }
    }
  },
  methods: {
    onSelectedPost(id) {
      if (!this.isAgentPerformance) {
        this.$store.state.rabbitSelectedPostId = id
      }
      this.selectedPost = id
      this.listPostsModal = false
      this.$emit('selectedPost', id)
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.size - this.size

        this.getProducts()
      }
    },
    getFacebookPost() {
      var vm = this
      var token = vm.selectedBot.page_access_token
      var pageid = vm.selectedBot.pageid
      var url = `https://graph.facebook.com/v4.0/${pageid}/posts?access_token=${token}`

      axios.get(url).then((response) => {
        if (response.status == 200) {
          vm.facebookPostList = response.data.data

          if (vm.facebookPostList) {
            vm.postCount = vm.facebookPostList.length
            vm.$store.state.rabbitSelectedPostId = vm.facebookPostList[0].id
          }
        }
      })
    },
    clearPost() {
      this.selectedPost = null
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/RabbitReplyFBPost/ReplyCommentSearchPost.vue